<template>
  <o-table :items="vehicles" :loading="loading" :draggable="false" default-sort="number">
    <b-table-column v-slot="{ row }" field="accessType" label="Accès" centered>
      <b-icon v-if="row.accessType === 'public'" size="is-small" type="is-success" icon="unlock" />
      <b-icon
        v-else-if="row.accessType === 'private'"
        size="is-small"
        type="is-danger"
        icon="lock"
      />
    </b-table-column>
    <b-table-column v-slot="{ row }" field="spotTracker.number" label="Spot" sortable>
      <router-link
        v-if="row.spotTracker"
        :to="{
          name: 'spotTracker.edit',
          params: { id: row.spotTracker.id },
        }"
      >
        {{ row.spotTracker.number }}
      </router-link>
    </b-table-column>
    <b-table-column v-slot="{ row }" field="queclinkTracker.number" label="Queclink" sortable>
      <router-link
        v-if="row.queclinkTracker"
        :to="{
          name: 'queclinkTracker.edit',
          params: { id: row.queclinkTracker.id },
        }"
      >
        {{ row.queclinkTracker.number }}
      </router-link>
    </b-table-column>
    <b-table-column v-slot="{ row }" field="neyosTracker.number" label="Neyos" sortable>
      <router-link
        v-if="row.neyosTracker"
        :to="{
          name: 'neyosTracker.edit',
          params: { id: row.neyosTracker.id },
        }"
      >
        {{ row.neyosTracker.number }}
      </router-link>
    </b-table-column>
    <b-table-column v-slot="{ row }" field="number" label="Dossard" sortable>
      {{ row.number }}
    </b-table-column>
    <b-table-column v-slot="{ row }" field="name" label="Nom" sortable>
      {{ row.name }}
    </b-table-column>
    <b-table-column v-slot="{ row }" field="gender" label="Genre">
      <b-icon v-if="row.gender === 'male'" type="is-info" icon="mars" />
      <b-icon v-else-if="row.gender === 'female'" type="is-danger" icon="venus" />
      <o-icon v-else-if="row.gender === 'mixed'" name="venus-mars" />
    </b-table-column>
    <b-table-column v-slot="{ row }" field="country" label="Pays">
      {{ row.country }}
    </b-table-column>
    <b-table-column v-slot="{ row }" field="liveCategory" label="Catégorie">
      {{ row.categoryName }}
    </b-table-column>
    <b-table-column v-slot="{ row }" label="">
      <div class="buttons are-small is-right">
        <b-button download @click="$emit('exportGpx', row)">
          <b-icon icon="file-export" />
        </b-button>
        <b-button
          type="is-primary"
          tag="router-link"
          :to="{
            name: 'live.edit.vehicle.edit',
            params: { liveVehicleId: row.id },
          }"
        >
          <b-icon icon="edit" />
        </b-button>
        <b-button type="is-danger" @click="$emit('delete', row)">
          <b-icon icon="trash" />
        </b-button>
      </div>
    </b-table-column>
  </o-table>
</template>

<script>
import OTable from '@components/Table.vue'
import {
  NEYOS_TRACKER_TYPE,
  QUECLINK_TRACKER_TYPE,
  SPOT_TRACKER_TYPE,
} from '@constants/tracker/type'

export default {
  name: 'LiveVehicleTable.vue',

  components: {
    OTable,
  },

  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    liveVehicles: {
      type: Array,
      required: true,
      validator: (v) =>
        v.every((obj) =>
          [
            'id',
            'name',
            'number',
            'gender',
            'country',
            'accessType',
            'trackers',
            'categoryName',
          ].every((key) => key in obj),
        ),
    },
  },

  computed: {
    vehicles() {
      return this.liveVehicles.map((vehicle) => {
        let spotTracker = null
        let queclinkTracker = null
        let neyosTracker = null

        for (const tracker of vehicle.trackers) {
          if (tracker.type === SPOT_TRACKER_TYPE) {
            spotTracker = tracker

            continue
          }

          if (tracker.type === QUECLINK_TRACKER_TYPE) {
            queclinkTracker = tracker

            continue
          }

          if (tracker.type === NEYOS_TRACKER_TYPE) {
            neyosTracker = tracker
          }
        }

        return {
          ...vehicle,
          spotTracker,
          queclinkTracker,
          neyosTracker,
        }
      })
    },
  },
}
</script>
